import { render } from "./DownloadReportsView.vue?vue&type=template&id=33673b49&scoped=true"
import script from "./DownloadReportsView.vue?vue&type=script&lang=js"
export * from "./DownloadReportsView.vue?vue&type=script&lang=js"

import "./DownloadReportsView.vue?vue&type=style&index=0&id=33673b49&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33673b49"]])

export default __exports__